import React from 'react'
import DepositForm from './DepositForm'
import DepositFilter from './DepositFilter';
import DepositList from './DepositList';
import DepositNotifications from './DepositNotifications';
import DepositProvider from './DepositProvider';
export default function Depositmain() {
  return (
    <div>
        <div >
        <h1>Deposit Management</h1>
    
    
  <DepositProvider>
      
                <DepositFilter />
                <DepositList />
                <DepositNotifications />
          
  </DepositProvider>
      
  
      </div>
    </div>
  )
}
